import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'om-empty-state',
  templateUrl: './empty-state.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyState {
  readonly icon = input('auto_stories');
  readonly title = input('');
  readonly description = input('');
}
